
import SsrCarousel from 'vue-ssr-carousel'
// eslint-disable-next-line no-unused-vars
import ssrCarouselCss from 'vue-ssr-carousel/index.css'
import featuredJobsData from '@/data/featuredJobs.json'

export default {
  name: 'JobFeed',
  components:{SsrCarousel},
  props: {
    limit: {
      type: String,
      default: '10',
    },
    featured: {
      type: Boolean,
      default: false,
    },
    items:{
      type: String,
      default: '3',
    },
    items_400:{
      type: String,
      default: '1',
    },
    items_500:{
      type: String,
      default: '2',
    },
    items_740:{
      type: String,
      default: '2',
    },
    items_900:{
      type: String,
      default: '3',
    },
    items_1040:{
      type: String,
      default: '3',
    },
    fwPage: {
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      isReady: false
    }
  },
  computed:{
    setTarget(){
      if (this.fwPage){
        return "_BLANK"
      } else {
        return ""
      }
    },
    jobs() {
      return featuredJobsData
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isReady = true
    })
  }
}
